import React, { useMemo } from 'react';

import { Box } from '@mui/system';
import { Paper } from '@mui/material';

import {
  AdvertisingBannerTypes,
  clientAdvertisements,
  Language,
  language,
} from '@pharmaplan/common';

import useProfessional from '../../../hooks/Professional/useProfessional';
import PPStaticEn from '../../../assets/img/PP-Promote PG-EN.png';
import PPStaticFr from '../../../assets/img/PP-Promote PG-FR.png';
import PGStaticEn from '../../../assets/img/PG-Promote PP-EN-V3.png';
import PGStaticFr from '../../../assets/img/PG-Promote PP-FR-V3.png';

import useWindowDimensions from '../../../hooks/useWindowDimensions';
import { useAppSelector } from '../../../hooks/useAppSelector';
import useSelfService from '../../../hooks/useSelfService';
import EnglishAd from '../../../assets/svg/englishAd.svg';
import FrenchAd from '../../../assets/svg/frenchAd.svg';

import AdsCarousel from './AdsCarousel';
import classes from './style';

const { en, fr } = Language;
const minHeight = 290;

const AdsContainer = () => {
  const { height } = useWindowDimensions();

  const { isSelfService } = useSelfService();
  const { isProfessional } = useProfessional();

  const userLanguage = useAppSelector(language);
  const ads = useAppSelector(clientAdvertisements);

  const { standard, legend } = useMemo(() => {
    const standardAds = ads?.filter?.(
      (item) =>
        item.bannerType === AdvertisingBannerTypes.standard,
    );
    const legendAds = ads?.filter?.(
      (item) =>
        item.bannerType === AdvertisingBannerTypes.legend,
    );
    return { legend: legendAds, standard: standardAds };
  }, [ads]);

  const legendHeight = 277.5;

  const { adsContainer, dynamicHeight, baseAdsContainerImg } = classes;

  const adConfig = {
    [en]: {
      src: EnglishAd,
      filler: isSelfService ? PGStaticEn : PPStaticEn,
    },
    [fr]: {
      src: FrenchAd,
      filler: isSelfService ? PGStaticFr : PPStaticFr,
    },
  };

  const { src, filler } = adConfig[userLanguage as keyof typeof adConfig];
  const { height: dynHeight } = dynamicHeight(height ?? 1, legendHeight);
  const calcHeight = Math.max(dynHeight, minHeight);

  return (
    <Box>
      {!isProfessional && (
        <>
          <Box component={Paper} sx={classes.staticContainer}>
            <AdsCarousel
              ads={
                legend?.length
                  ? legend
                  : [
                    {
                      imageUrl: filler,
                      imageName: '1',
                      navigateUrl: '1',
                      bannerType: AdvertisingBannerTypes.legend,
                    },
                  ]
              }
              height={93}
            />
          </Box>
          <Box sx={{ mb: 1 }} />
        </>
      )}

      <Box sx={[adsContainer]} component={Paper}>
        {ads?.length ? (
          <AdsCarousel ads={standard} height={calcHeight} />
        ) : (
          <Box
            component="img"
            sx={[
              baseAdsContainerImg,
              { height: calcHeight - 5, width: '100%' },
            ]}
            src={src}
            alt="PharmaPlan ad"
          />
        )}
      </Box>
    </Box>
  );
};

export default AdsContainer;
